module.exports = __webpack_public_path__ + "static/media/cross.02eba01c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/cross.svg
// module id = 192
// module chunks = 0